export const ENTERED_FROM_SEARCH_BAR = 'alfinder_entered_from_search_bar';
export const ENTERED_FROM_RECOMMENDATIONS =
  'alfinder_entered_from_recommendations';
export const ENTERED_FROM_SEARCH_PAGE = 'alfinder_entered_from_search_page';
export const CLICKED_PRODUCT_ID = 'alfinder_clicked_product_id';

export const ENTERED_FROM_FBT = 'alfinder_entered_from_fbt';
export const ENTERED_FROM_FBT_MODAL = 'alfinder_entered_from_fbt_modal';
